import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import firebase from "../firebase/firebase";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CircularProgress from '@mui/material/CircularProgress';
import moment from "moment";
import IconButton from "@mui/material/IconButton/IconButton";
import LinkTwoToneIcon from "@mui/icons-material/LinkTwoTone";
import axios from "axios";
export default function ChatMediaTabs({room}) {
  const [value, setValue] = React.useState('media');
  const [media, setMedia] = React.useState([]);
  const [contracts, setContracts] = React.useState([]);
  const [files, setFiles] = React.useState([]);
  const [links, setLinks] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const imagePattern = /.png|.jpg|.gif/
  const videoPattern = /.mp4|.mov|.webm|.wmv/
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const detect = (name) => {
    if (imagePattern.test(name)) {
      return 'i'
    }
    if (videoPattern.test(name)) {
      return 'v'
    }

  }
  const getLinks = async () => {
    try {
      setLinks([])
      setLoading(true)
      let roomRef =firebase.firestore()
        .collection('messages')
        ;
      roomRef =roomRef.where('roomId', '==', room);
      roomRef =roomRef.where('type', '==', 'link');
      roomRef =roomRef.orderBy("createdAt", "desc");
      const linkSnapshot = await roomRef.get()

      if (linkSnapshot && linkSnapshot.docs && linkSnapshot.docs.length > 0) {
        const list = linkSnapshot.docs.map((lk) => ({...lk.data(), id: lk.id}));
        const metaList = []
        for (let l of list) {

          try {

            const response = await axios.post(
              'https://api-taost.herokuapp.com/meta-data',
              { url: l?.text },
              { headers: { 'Content-Type': 'application/json',}  }
            )
            metaList.push({...l, metadata: response.data})
          } catch (e) {
            metaList.push({...l})
          } finally {

            if (list.length === metaList.length) {
              setLoading(false)

              setLinks(metaList)

            }
          }
        }

      }
    } catch (err) {

    }
  }
  const getAllMedia = async () => {
    if (room) {
      setFiles([])
      setMedia([])
      try {
        // const metaURLdata = await urlMetadata('https://twitter.com/CryptoRocky')
        //
        setLoading(true)
        const storageRef = firebase.storage().ref();
        const mediaFiles = await storageRef.child(`chats/${room}/media/`)
          .listAll()

        if (mediaFiles.items.length > 0) {
          const list = []
          for (let med of mediaFiles?.items) {
            const url = await med.getDownloadURL()
            const metadata = await med.getMetadata();
            list.push({
              downloadURL: url,metadata,
              ...med
            })
            if (mediaFiles.items.length === list.length) setMedia(list)
          }
        }
        const attachmentFiles = await storageRef.child(`chats/${room}/attachment/`)
          .listAll()
        if (attachmentFiles.items.length > 0) {
          const list = []
          for (let med of attachmentFiles?.items) {
            const url = await med.getDownloadURL()
            const metadata = await med.getMetadata();

            list.push({
              downloadURL: url,metadata,
              ...med
            })
            if (attachmentFiles.items.length === list.length)  setFiles(list);
          }
        }

        const contractFiles = await storageRef.child(`chats/${room}/contract/`)
          .listAll()
        if (contractFiles.items.length > 0) {
          const list = []
          for (let med of contractFiles?.items) {
            const url = await med.getDownloadURL()
            const metadata = await med.getMetadata();

            list.push({
              downloadURL: url,metadata,
              ...med
            })
            if (contractFiles.items.length === list.length)  setContracts(list);
          }
        }
        setLoading(false)

      } catch (e) {
        setLoading(false)

      }



    }

  }
  const fileIconColor = (name) => {
    if (name === 'pdf') {
      return '#ED1C24'
    } else if (name === 'doc' || name === 'docx' ) {
      return '#1ab1e8'
    } else if (name === 'xls' || name === 'xlsx') {
      return '#00a954'
    }else {
      return '#a77b00'
    }
  }
  React.useEffect(() => {
    if (value === 'link') {
      getLinks()
    } else getAllMedia();


  }, [room])


  return (
    <><Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        centered={true}
        aria-label="wrapped label tabs example"

      >
        <Tab
          value="media"
          label="Media"
          sx={{fontWeight: 700}}
        />
        <Tab value="files" label="Files"  sx={{fontWeight: 700}}/>
        <Tab value="link" label="Link"  sx={{fontWeight: 700}} onClick={() => getLinks()}/>
      </Tabs>
    </Box>

      {loading ? <Stack sx={{ width: '100%', height: 'calc(100vh - 50px)' }}   direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}>
        <CircularProgress />
      </Stack> :
    <Box>
      {value === 'media' && media.length > 0 &&
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          py={2}

        >


          {value === 'media' && media.length > 0 &&
            media.map((m) => (

              <Box  sx={{m:.5, height: 80, width:80, cursor:'pointer','&:hover': {
                  opacity: .8,

                }}}>
                {detect(m?._delegate?.name) === 'i' &&
                  <img src={m?.downloadURL} alt={m?._delegate?.name} style={{height: 80, width:80, objectFit:'cover' ,
                    }}/>
                }

                {detect(m?._delegate?.name) === 'v' &&
                  <video src={m?.downloadURL} alt={m?._delegate?.name} style={{height: 80, width:80, objectFit:'cover', }} autoPlay={false} controls={false}/>
                }

              </Box>))

          }

        </Grid>

      }



      {value === 'files' && files.length > 0 &&
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{width: '100%'}}
        >
          {value === 'files' && files.length > 0 &&
            files.map((m) => (
              <Box sx={{'&:hover': {
                  backgroundColor: '#eeeeee',

                }}}>
                <Stack direction={'column'} spacing={.5} py={1}
                       px={1} sx={{width: '100%', borderBottom: '1px solid #ccc'}} alignItems={'flex-end'}>

                  <Stack
                    direction={'row'}
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{width: '100%'}}
                    spacing={2}

                  >
                    <Box sx={{

                      height: 50,
                      background: fileIconColor(m?._delegate?.name.split('.')[m?._delegate?.name.split('.').length -1]),
                      borderRadius: '3px',
                      color:'#fff',
                      fontSize:'small',
                      padding: '15px 10px',
                      textTransform:'uppercase'
                    }} >

                      {m?._delegate?.name.split('.')[m?._delegate?.name.split('.').length -1]}
                    </Box>
                    <Stack direction={'column'} spacing={.5}>

                      <Typography variant={'body1'} noWrap={true} sx={{width: 200}}>
                        {m?._delegate?.name}
                      </Typography>
                      <Typography variant={'caption'}>
                        {(m?.metadata?.size/1024/1024).toFixed(0) == 0 ? (m?.metadata?.size/1024).toFixed(0) + ' KB' :(m?.metadata?.size/1024/1024).toFixed(0) + ' MB'}
                      </Typography>

                    </Stack>
                  </Stack>
                  <Typography variant={'caption'}>
                    {moment(m?.metadata?.timeCreated).format('DD/MM/YYYY')}
                  </Typography>
                </Stack>

              </Box>

                ))


          }
          {value === 'files' && media.length > 0 &&
            media.map((m) => (
              <Box sx={{'&:hover': {
                  backgroundColor: '#eeeeee',

                }}}>
                <Stack direction={'column'} spacing={.5} py={1}
                       px={1} sx={{width: '100%', borderBottom: '1px solid #ccc'}} alignItems={'flex-end'}>

                  <Stack
                    direction={'row'}
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{width: '100%'}}
                    spacing={2}

                  >
                    <Box sx={{

                      height: 50,
                      background: fileIconColor(m?._delegate?.name.split('.')[m?._delegate?.name.split('.').length -1]),

                      borderRadius: '3px',
                      color:'#fff',
                      fontSize:'small',
                      padding: '15px 10px',
                      textTransform:'uppercase'
                    }} >

                      {m?._delegate?.name.split('.')[m?._delegate?.name.split('.').length -1]}
                    </Box>
                    <Stack direction={'column'} spacing={.5}>

                      <Typography variant={'body1'} noWrap={true} sx={{width: 200}}>
                        {m?._delegate?.name}
                      </Typography>
                      <Typography variant={'caption'}>
                        {(m?.metadata?.size/1024/1024).toFixed(0) == 0 ? (m?.metadata?.size/1024).toFixed(0) + ' KB' :(m?.metadata?.size/1024/1024).toFixed(0) + ' MB'}
                      </Typography>

                    </Stack>
                  </Stack>
                  <Typography variant={'caption'}>
                    {moment(m?.metadata?.timeCreated).format('DD/MM/YYYY')}
                  </Typography>
                </Stack>

              </Box>

            ))


          }
          {value === 'files' && contracts.length > 0 &&
            contracts.map((m) => (
              <Box sx={{'&:hover': {
                  backgroundColor: '#eeeeee',

                }}}>
                <Stack direction={'column'} spacing={.5} py={1}
                       px={1} sx={{width: '100%', borderBottom: '1px solid #ccc'}} alignItems={'flex-end'}>

                  <Stack
                    direction={'row'}
                    justifyContent="flex-start"
                    alignItems="center"
                    sx={{width: '100%'}}
                    spacing={2}

                  >
                    <Box sx={{

                      height: 50,
                      background: fileIconColor(m?._delegate?.name.split('.')[m?._delegate?.name.split('.').length -1]),

                      borderRadius: '3px',
                      color:'#fff',
                      fontSize:'small',
                      padding: '15px 10px',
                      textTransform:'uppercase'
                    }} >

                      {m?._delegate?.name.split('.')[m?._delegate?.name.split('.').length -1]}
                    </Box>
                    <Stack direction={'column'} spacing={.5}>

                      <Typography variant={'body1'} noWrap={true} sx={{width: 200}}>
                        {m?._delegate?.name}
                      </Typography>
                      <Typography variant={'caption'}>
                        {(m?.metadata?.size/1024/1024).toFixed(0) == 0 ? (m?.metadata?.size/1024).toFixed(0) + ' KB' :(m?.metadata?.size/1024/1024).toFixed(0) + ' MB'}
                      </Typography>

                    </Stack>
                  </Stack>
                  <Typography variant={'caption'}>
                    {moment(m?.metadata?.timeCreated).format('DD/MM/YYYY')}
                  </Typography>
                </Stack>

              </Box>

            ))


          }




        </Grid>

      }


      {
        value === 'link' && links.length > 0 &&

        links.map((link) => (

          <Box sx={{'&:hover': {
              backgroundColor: '#eeeeee',

            }}}>

            <Stack direction={'column'} spacing={.5} py={1}
                   px={1} sx={{width: '100%', borderBottom: '1px solid #ccc'}} alignItems={'flex-end'}>

              <Stack
                direction={'row'}
                spacing={2} justifyContent="flex-start"
                alignItems="center">

                {link?.metadata && link?.metadata?.image ? <img src={link?.metadata.image} style={{height: 75, width:75}}/> :
                  <Box sx={{

                    background: '#8888881c',
                    borderRadius: '3px',
                    color:'#fff',
                    fontSize:'small',
                    padding: '14px 9px',
                    textTransform:'uppercase'
                  }} ><IconButton   href={link?.text} target={'_blank'} ><LinkTwoToneIcon  style={{color: 'rgb(40 40 40)'}} /></IconButton></Box>


                }
                <Stack direction={'column'} sx={{flex: 1}}>
                  <Typography variant={'subtitle1'} noWrap={true} sx={{ width:150  }} >
                    {link?.metadata && link?.metadata?.title }
                  </Typography>

                  <Typography variant={'body2'} sx={{ flex:1, wordBreak: 'break-all'}} >
                    {link?.text}
                  </Typography>
                </Stack>
              </Stack>

              <Stack direction={'row'} spacing={.5}>

                <Typography variant={'caption'} color={'secondary'}>
                  {link.createdAt && moment(link.createdAt.seconds * 1000).format('DD/MM/YYYY')}
                </Typography>
              </Stack>
            </Stack>

          </Box>
        ))
      }


    </Box>
      }

    </>
  );
}